// src/components/ProductionProjects.js
import React from "react";
import "../styles/ProductionProjects.css";
import channels from "../assets/channels.json";

const ProductionProjects = () => {
  return (
    <div className="youtube-slider">
      {channels.map((channel, index) => (
        <div className="youtube-channel" key={index}>
          <div className="channel-header">
            <img className="banner" src={channel.banner} alt="Banner" />
            <div className="channel-info">
              <img className="channel-logo" src={channel.logo} alt="Profil Fotoğrafı" />
              <div className="channel-meta">
                <h2>
                  <a
                    href={channel.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {channel.name}
                  </a>
                </h2>
                <p className="description">{channel.description}</p>
              </div>
              <a
                href={`${channel.link}?sub_confirmation=1`}
                target="_blank"
                rel="noopener noreferrer"
                className="subscribe-button"
              >
                Abone Ol
              </a>
            </div>
          </div>

          <div className="video-grid">
            {channel.videos.map((video, i) => (
              <div className="video-card" key={i}>
                <iframe
                  src={video}
                  title={`Video ${i + 1}`}
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ProductionProjects;